import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer } from "antd";
import PropTypes from "prop-types";
import "./index.css";
import React, { useEffect, useRef, useState } from "react";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// #TODO if possible unify this with "Drawer" inside Vapor folder

const VaporDrawer = props => {
  const {
    children,
    closeOnRight,
    buttons,
    leftButtons,
    footer,
    hideFooter,
    maskClosable,
    onClose,
    subtitle,
    title,
    titleAlign,
    visible,
    width,
    customClassName,
    mask
  } = props;

  const [isVisible, setIsVisible] = useState(visible);

  const defWidth = 500;
  const defButton = closeOnRight ? 0 : 48;

  const drawerDetailRef = useRef();

  useEffect(() => {
    if (!drawerDetailRef.current) return undefined;
    let ps = new Scrollbar(drawerDetailRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [drawerDetailRef?.current]);

  const CloseIcon = () => {
    return (
      <div
        className="ts-vapor-drawer-close-icon"
        /* style={{ right: width - defButton || defWidth - defButton }}*/
        style={!closeOnRight ? {left: 0} : {float: "right"}}
      >
        <FontAwesomeIcon icon={["fal", "times"]} />
      </div>
    );
  };

  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);
  
  return (
    <Drawer
      // eslint-disable-next-line
      {...props}
      title={
        <div className={"ts-vapor-drawer-title " + titleAlign}>
          <span style={{textTransform: "uppercase"}}>{title}</span>
          <span>{subtitle}</span>
        </div>
      }
      className={`ts-vapor-drawer ${
        hideFooter ? "hideFooter" : ""
      } ${customClassName && customClassName} ${closeOnRight ? "closeOnRight" : ""}`}
      destroyOnClose={false}
      footer={
        !hideFooter && (
          <div className="ts-vapor-drawer-footer">
            {footer || leftButtons ? (
              <div className="ts-vapor-drawer-footer-buttons-container">
                <div>{leftButtons}</div>
                <div>{buttons}</div>
              </div>
            ) : (
              buttons
            )}
          </div>
        )
      }
      onCancel={() => {
        setIsVisible(false);
      }}
      footerStyle={{ width: width ? `calc(100% - ${defButton}px)` : (defWidth - defButton) }}
      afterVisibleChange={val => {
        if (!val && onClose) onClose();
      }}
      onClose={() => setIsVisible(false)}
      closable={true}
      mask={mask}
      maskClosable={maskClosable}
      visible={isVisible}
      bodyStyle={{ width: width ? `calc(100% - ${defButton}px)` : (defWidth - defButton) }}
      width={width || defWidth}
      closeIcon={props.closeIcon ? props.closeIcon : <CloseIcon />}
      
    >
      <div ref={drawerDetailRef} style={{height: "100%", position: "relative"}} className="vapor-drawer-container">
        {children}
      </div>
    </Drawer>
  );
};

VaporDrawer.propTypes = {
  titleAlign: PropTypes.oneOf(["left", "center", "right"])
};

VaporDrawer.defaultProps = {
  titleAlign: "left"
};

export default VaporDrawer;
